var _path, _path2, _circle, _circle2, _path3, _circle3, _circle4, _path4, _path5;
var _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
var SvgPolls = function SvgPolls(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 512,
    viewBox: "0 0 60 60",
    width: 512,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M55 0H13a5 5 0 00-5 5v43H2a2 2 0 00-2 2v5a5 5 0 005 5h42a5 5 0 005-5V12h6a2 2 0 002-2V5a5 5 0 00-5-5zM9 58H5a3 3 0 01-3-3v-5h40v5c0 1.08.35 2.14 1 3zm41-3a3 3 0 01-6 0v-5a2 2 0 00-2-2H10V5a3 3 0 013-3h38.03A4.95 4.95 0 0050 5zm8-45h-6V5a3 3 0 016 0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22 5a9 9 0 100 18 9 9 0 000-18zm0 16a7 7 0 110-14 7 7 0 010 14zM22 27a9 9 0 100 18 9 9 0 000-18zm0 16a7 7 0 110-14 7 7 0 010 14z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 13,
    r: 1
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 26,
    cy: 13,
    r: 1
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.49 15.13a1 1 0 00-1.36.38.72.72 0 01-.2.21c-.12.09-.25.16-.39.2-.35.1-.73.1-1.08 0a1.37 1.37 0 01-.4-.2.73.73 0 01-.19-.2 1 1 0 10-1.74.97c.18.32.43.6.73.83a3.82 3.82 0 003.29.5c.35-.1.69-.28.99-.5.3-.22.55-.5.73-.83a1 1 0 00-.38-1.36z"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 35,
    r: 1
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 26,
    cy: 35,
    r: 1
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.14 37.68a3.84 3.84 0 00-3.29-.5c-.35.1-.69.28-.99.5-.3.22-.55.5-.73.83a1 1 0 101.74.98.72.72 0 01.2-.21c.12-.09.25-.16.39-.2.35-.1.73-.1 1.08 0 .14.04.27.11.4.2.07.05.14.13.19.2a1 1 0 101.74-.97c-.18-.32-.43-.6-.73-.83zM45 15a1 1 0 00-1 1v2h-8v-8h6a1 1 0 000-2h-6a2 2 0 00-2 2v8c0 1.1.9 2 2 2h8a2 2 0 002-2v-2a1 1 0 00-1-1zM44 30h-8a2 2 0 00-2 2v8c0 1.1.9 2 2 2h8a2 2 0 002-2v-8a2 2 0 00-2-2zm-8 10v-8h8v8z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M46.3 8.3L41 13.58l-1.3-1.3a1 1 0 00-1.4 1.42l2 2a1 1 0 001.4 0l6-6a1 1 0 00-1.4-1.42z"
  })));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPolls, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/polls.984b3e2b.svg";
export { ForwardRef as ReactComponent };